// Import all endpoints here
import { process } from "./process";
import { profile } from "./profile";
import { auth } from "./authentication";
import { form } from "./form";
import { list } from "./list";
import { forgotPassword } from "./forgotPassword";
import { downloadHelper } from "./downloadHelper";
import { additionalDocs } from "./additionalDocuments";
import { general } from "./general";
import { patients } from "./patients";
import { secondopinion } from "./secondopinion";
import { auditVisit } from "./auditVisit";
import { assessment } from "@/api/assessment";
import { visits } from "./visits";

export const api = {
  process,
  profile,
  auth,
  form,
  list,
  forgotPassword,
  downloadHelper,
  additionalDocs,
  general,
  patients,
  secondopinion,
  auditVisit,
  assessment,
  visits,
};
